import { call, takeLatest } from "redux-saga/effects";
import apiRequest from "utils/api";

export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";

const initialState = {
  showForgotPasswordEmailSentToastMessage: false
};

// Reducer
export default function forgotPasswordReducer(state = initialState, { type, payload }) {
  switch (type) {
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        showForgotPasswordEmailSentToastMessage: true
      };
    default:
      return state;
  }
}

// Action
export function forgotPasswordRequest(payload) {
  return {
    type: FORGOT_PASSWORD_REQUEST,
    payload
  };
}

// Saga
function* forgotPasswordRequestSaga(action) {
  const { payload } = action;
  yield call(apiRequest, "/forgotPassword", "POST", payload);
}

export function* forgotPasswordSaga() {
  yield takeLatest(FORGOT_PASSWORD_REQUEST, forgotPasswordRequestSaga);
}
